import React, { Component } from "react";
import { Col, Row, Form, Button } from "react-bootstrap";
import Pagination from "../Pagination/Pagination";
import classes from "./extInterview.module.css";
import { NavLink } from "react-router-dom";
import search from "../../Assets/icons/0.75x/searchldpi.png";
import { connect } from "react-redux";
import * as actionTypes from "../../Action/Index";
import Loader from "react-loader-advanced";
import Spinner from "react-bootstrap/Spinner";
import NoDataErrorScreen from "../commonComponents/NoDataErrorScreen";
import ServerErrorScreen from "../commonComponents/ServerErrorScreen";
import "./progressbar.css";
import Modal from "../ScheduleInterviewerProfileView/interviewProfileView";
import Availability from "./Availability";
import loading from "../../Assets/Images/loader-green.gif";
import SweetAlert from "../commonComponents/SweetAlert";
import NewSweetAlert from "react-bootstrap-sweetalert";
import "../commonComponents/SweetAlert.css";
import recommend from "../../Assets/icons/1.5x/Bighdpi.png";
import { withRouter } from "react-router-dom";
class candidateProfile extends Component {
  state = {
    currentPage: 1,
    searchItem: [],
    interviewerError: "",
    slotError: "",
    show: false,
    email: "",
    image: null,
    id: null,
    availability: "",
    availabilityModal: false,
    interviewerId: "",
    interviwerRadioId: "",
    selectId: "",
    scheduleInterviewInterviewerList: [],
    prevLimit: 0,
    nextLimit: 6,
    remainingBalance: 0,
    interviewerAmount: 0,
    records: 0,
    totalInterviewTaken: 0,
    notifyFail: false,
    notifySuccess: false,
  };

  onRadioSelect = (e) => {
    this.setState({
      interviewerId: this.state.id,
      text: e.target.value,
    });
    this.props.onRadioSelect(e.target.value);
    this.matchIds();
  };
  availabilityModalHandler = () => {
    this.setState({
      availabilityModal: false,
    });
  };
  handleModal = (totalInterviewTaken, ev, picture, id) => {
    this.setState({
      show: !this.state.show,
      email: ev,
      image: picture,
      id: id,
      totalInterviewTaken: totalInterviewTaken,
    });
  };

  onPageChange = (id) => {
    this.setState({
      currentPage: 1,
    });
    // this.setState({
    //     currentPage: id
    // }, () => {
    //     this.props.getScheduleInterviwerList(this.state.currentPage, this.state.searchItem)
    // })
    // this.props.interviewerPageNumber(id)
  };
  onLeftChange = () => {
    if (this.state.prevLimit === 0) {
      return;
    }
    this.setState({
      prevLimit: this.state.prevLimit - 6,
      nextLimit: this.state.nextLimit - 6,
      currentPage: this.state.currentPage - 1,
    });
  };
  onRightChange = () => {
    if (this.props.records <= this.state.nextLimit) {
      return;
    }
    this.setState({
      prevLimit: this.state.prevLimit + 6,
      nextLimit: this.state.nextLimit + 6,
      currentPage: this.state.currentPage + 1,
    });
  };

  componentDidMount() {
    this.props.getScheduleInterviwerList(
      this.state.currentPage,
      this.state.searchItem,
      this.props.jobId,
      this.props.selecttypeofInterviewValue,
      this.props.candidateId
    );
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.sufficientBalance != true) {
      this.props.history.push("/interview");
    }
    if (nextProps.scheduleInterviewInterviewerList != null) {
      this.setState({
        scheduleInterviewInterviewerList:
          nextProps.scheduleInterviewInterviewerList,
        remainingBalance: nextProps.remainingBalance,
        records: nextProps.records,
        notifyFail: nextProps.notifyFoxmatrixFailMsg,
        notifySuccess: nextProps.notifyFoxmatrixSuceess,
      });
    }
  }

  handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
    this.setState({
      prevLimit: 0,
      nextLimit: 6,
      currentPage: 1,
    });
    const newarr = this.searchField.value;
    let arr = [];
    if (newarr !== "") {
      arr = newarr.split(",");
      this.props.getScheduleInterviwerList(
        this.state.currentPage,
        arr,
        this.props.jobId,
        this.props.selecttypeofInterviewValue,
        this.props.candidateId
      );
    } else {
      this.props.getScheduleInterviwerList(
        this.state.currentPage,
        arr,
        this.props.jobId,
        this.props.selecttypeofInterviewValue,
        this.props.candidateId
      );
    }
  };
  check = (event) => {
    let x = document.getElementsByTagName("tr");
    let i;
    for (i = 0; i < x.length; i++) {
      x[i].style.boxShadow = "none";
    }
    //event.target.parentNode.parentNode.parentNode.style.boxShadow = "0px 0px 0px 1px #00a99d"
  };

  availableCheck = () => {
    this.props.gotoScheduleInterview();
    this.setState({ interviewerError: "Please select an interviewer profile" });
  };

  hideAlert_1 = () => {
    this.setState({
      interviewerError: "",
    });
  };

  hideAlert_2 = () => {
    this.setState(
      {
        slotError: "",
        notifyFail: false,
        notifySuccess: false,
      },
      () => {
        this.props.clearStateNotify();
      }
    );
  };

  matchIds = () => {
    if (this.props.id !== this.state.selectId) {
      this.props.onRadioUnselectInterviewer();
      // this.props.onRadioSelectInterviewer({id: this.state.id})
    }
  };

  notify = () => {
    let data = [this.props.jobId, this.searchField.value];
    this.props.notifyFoxmatrix(data);
  };

  i = 0;

  render() {
    return (
      <>
        <Row>
          <Col md={12}>
            <div className={classes.heading}>
              <h3>Schedule Interview</h3>
            </div>
          </Col>
        </Row>
        <Row className="justify-content-md-center">
          <Col md={9}>
            <ul className="progress-tracker progress-tracker--text progress-tracker--text-inline progress-tracker--spaced">
              <li className="progress-step is-complete">
                <div className="progress-marker" data-text="1">
                  <div className="progress-text">
                    <h6 className="progress-title color">Job Profile</h6>
                  </div>
                </div>
              </li>

              <li className="progress-step is-complete">
                <div className="progress-marker" data-text="2">
                  <div className="progress-text">
                    <h6 className="progress-title color">Candidate Profile</h6>
                  </div>
                </div>
              </li>

              <li className="progress-step is-active" aria-current="step">
                <div className="progress-marker" data-text="3">
                  <div className="progress-text">
                    <h6 className="progress-title color">Interviewer</h6>
                  </div>
                </div>
              </li>

              <li className="progress-step">
                <div className="progress-marker" data-text="4">
                  <div className="progress-text">
                    <h6 className="progress-title">Interview Details</h6>
                  </div>
                </div>
              </li>
            </ul>
          </Col>
        </Row>
        <Loader
          show={this.props.loader || this.props.notifyFoxmatrixLoader}
          message={<img src={loading} />}
          foregroundStyle={{ color: "#00a99d" }}
          backgroundStyle={{ backgroundColor: "#F3EFEF" }}
        >
          <Row className={classes.gapTop}>
            <Col md={8}>
              <Form
                className="form-inline"
                onSubmit={(e) => this.handleSubmit(e)}
              >
                <Form.Group className="mx-sm-4">
                  <Form.Control
                    type="text"
                    className={`${classes.inputText} shadow-none`}
                    ref={(element) => (this.searchField = element)}
                    name="search"
                    maxLength="52"
                    placeholder="Search by Name or Position Title"
                  />
                </Form.Group>

                <Button
                  type="submit"
                  variant="warning"
                  className={` ${classes.searchButton} ${classes.btnWarning} `}
                >
                  <img
                    type="image/svg+xml"
                    width="25px"
                    src={search}
                    alt="search"
                  />
                </Button>
              </Form>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              {this.state.interviewerError !== "" ? (
                <NewSweetAlert
                  style={{ width: "400px", marginLeft: "-210px" }}
                  warning
                  onConfirm={this.hideAlert_1}
                  confirmBtnBsStyle="none"
                  confirmBtnCssClass="confirmButtonStyle"
                >
                  {this.state.interviewerError}
                </NewSweetAlert>
              ) : null}
              {this.state.slotError !== "" ? (
                <NewSweetAlert
                  style={{ width: "400px", marginLeft: "-210px" }}
                  warning
                  onConfirm={this.hideAlert_2}
                  confirmBtnBsStyle="none"
                  confirmBtnCssClass="confirmButtonStyle"
                >
                  {this.state.slotError}
                </NewSweetAlert>
              ) : null}
              {this.state.notifyFail === true ? (
                <NewSweetAlert
                  style={{ width: "400px", marginLeft: "-210px" }}
                  warning
                  onConfirm={this.hideAlert_2}
                  confirmBtnBsStyle="none"
                  confirmBtnCssClass="confirmButtonStyle"
                >
                  {`Unable to notify. Please try again`}
                </NewSweetAlert>
              ) : null}
              {this.state.notifySuccess === true ? (
                <NewSweetAlert
                  style={{ width: "400px", marginLeft: "-210px" }}
                  success
                  onConfirm={this.hideAlert_2}
                  confirmBtnBsStyle="none"
                  confirmBtnCssClass="confirmButtonStyle"
                >
                  {`Thank You for notifying us.\r\n We will get back you after onboarding interviewers for this job profile.`}
                </NewSweetAlert>
              ) : null}
              {/* <span className={classes.error}>&nbsp; {this.state.error}</span> */}
            </Col>
          </Row>

          {!this.props.serverErrorStatus ||
          this.props.notifyFoxmatrixNetworkError ? (
            this.state.scheduleInterviewInterviewerList.length !== 0 ? (
              !this.props.scheduleInterviewInterviewerNodata ? (
                <>
                  <Row>
                    <Col md={12} className="table-responsive">
                      <table className={classes.scheduleTbl}>
                        <thead>
                          <tr>
                            <th> &nbsp; </th>
                            <th> &nbsp; </th>
                            <th>Interviewer Name</th>
                            <th>Position Title</th>
                            <th>Experience</th>
                            <th style={{ width: "22%" }}>Availability</th>
                            <th>Amount</th>
                            <th>Rating</th>
                          </tr>
                        </thead>
                        <tbody id="interviewer">
                          {this.state.scheduleInterviewInterviewerList
                            .slice(this.state.prevLimit, this.state.nextLimit)
                            .map((element, index) => {
                              let obj = {
                                id: element.interviewerId,
                                name: element.name,
                                profile: element.profile,
                                experienceInYears: element.experienceInYears,
                                experienceInMonths: element.experienceInMonths,
                              };
                              return (
                                <tr key={index}>
                                  <td>
                                    {element.recommendation != undefined &&
                                    element.recommendation != null &&
                                    element.recommendation != "" ? (
                                      <img
                                        title={element.recommendation}
                                        style={{
                                          position: "relative",
                                          top: "-18px",
                                          left: "-15px",
                                        }}
                                        type="image/svg+xml"
                                        width="20px"
                                        src={element.recommendationPhoto}
                                      />
                                    ) : null}
                                  </td>
                                  <td width="5%">
                                    <label className={classes.profile}>
                                      <input
                                        type="radio"
                                        required
                                        onClick={(e) => {
                                          this.props.onRadioSelectInterviewer(
                                            e
                                          );
                                          this.setState({
                                            selectId: element.interviewerId,
                                            interviewerAmount: element.amount,
                                          });
                                        }}
                                        onChange={(e) => this.check(e)}
                                        value={JSON.stringify(obj)}
                                        name="interviewer"
                                        checked={
                                          this.props.interviewerProfileValue
                                            .id == element.interviewerId
                                        }
                                      />
                                      <span
                                        className={classes.checkmark}
                                      ></span>
                                    </label>
                                    {/* this.state.interviewerId!=element.interviewerId &&  */}
                                  </td>
                                  <td
                                    onClick={() =>
                                      this.handleModal(
                                        element.totalInterviewTaken,
                                        element.email,
                                        element.interviewerProfilePicPath,
                                        element.interviewerId
                                      )
                                    }
                                  >
                                    {element.name}
                                  </td>
                                  <td
                                    onClick={() =>
                                      this.handleModal(
                                        element.totalInterviewTaken,
                                        element.email,
                                        element.interviewerProfilePicPath,
                                        element.interviewerId
                                      )
                                    }
                                  >
                                    {element.profile !== null
                                      ? element.profile.length > 60
                                        ? element.profile.substring(0, 60) +
                                          "..."
                                        : element.profile
                                      : null}
                                  </td>

                                  <td
                                    onClick={() =>
                                      this.handleModal(
                                        element.totalInterviewTaken,
                                        element.email,
                                        element.interviewerProfilePicPath,
                                        element.interviewerId
                                      )
                                    }
                                  >
                                    {element.experienceInYears}{" "}
                                    {element.experienceInYears <= 1
                                      ? "year"
                                      : "years"}{" "}
                                    {element.experienceInMonths}{" "}
                                    {element.experienceInMonths <= 1
                                      ? "month"
                                      : "months"}
                                  </td>
                                  <td
                                    style={{
                                      color: "#fbb03b",
                                      textDecoration: "underline",
                                    }}
                                    onClick={() => {
                                      this.props.setAvailability(
                                        element.availability
                                      );
                                      this.setState({
                                        availabilityModal: true,
                                        interviwerRadioId: obj,
                                      });
                                    }}
                                  >
                                    {this.props.interviewerProfileValue.id ==
                                    element.interviewerId
                                      ? this.props.text
                                      : "Select"}
                                  </td>
                                  <td
                                    onClick={() =>
                                      this.handleModal(
                                        element.totalInterviewTaken,
                                        element.email,
                                        element.interviewerProfilePicPath,
                                        element.interviewerId
                                      )
                                    }
                                  >
                                    {element.amount}
                                  </td>
                                  <td
                                    onClick={() =>
                                      this.handleModal(
                                        element.totalInterviewTaken,
                                        element.email,
                                        element.interviewerProfilePicPath,
                                        element.interviewerId
                                      )
                                    }
                                  >
                                    {element.averageRating}
                                  </td>
                                </tr>
                              );
                            })}
                        </tbody>
                      </table>
                    </Col>
                  </Row>
                  <div className={classes.footer}>
                    <Row>
                      <Col md={1}></Col>
                      <Col md={2}>
                        <Button
                          type="button"
                          onClick={this.props.gotoSelectCandidate}
                          variant="warning"
                          className={classes.nextBtn}
                        >
                          {" "}
                          Previous{" "}
                        </Button>
                      </Col>
                      <Col md={6}>
                        {this.props.records > 6 ? (
                          <Pagination
                            activePage={this.state.currentPage}
                            pageRangeDisplayed={Math.ceil(
                              this.props.records / 6
                            )}
                            onPageChange={this.onPageChange}
                            onLeftChange={this.onLeftChange}
                            onRightChange={this.onRightChange}
                          />
                        ) : null}
                      </Col>
                      <Col md={2}>
                        <Button
                          type="button"
                          onClick={() =>
                            this.state.remainingBalance >
                            this.state.interviewerAmount
                              ? this.props.text == "Select"
                                ? this.setState({
                                    slotError:
                                      " Please select the interviewer and Availability slot",
                                  })
                                : this.availableCheck()
                              : this.setState({
                                  slotError: "You account balance is too low",
                                })
                          }
                          variant="warning"
                          className={classes.nextBtn}
                        >
                          {" "}
                          Next{" "}
                        </Button>
                      </Col>
                      <Col md={1}></Col>
                    </Row>
                  </div>
                  <br />
                </>
              ) : (
                <>
                  {" "}
                  <NoDataErrorScreen msg="No results found" />
                  <Row className="justify-content-md-center">
                    <Col md={3}>
                      <Button
                        type="button"
                        variant="warning"
                        className={`${classes.searchButton} ${classes.btnWarning}`}
                        onClick={this.notify}
                      >
                        Notify
                      </Button>
                    </Col>
                  </Row>
                  <div className={classes.footer}>
                    <Row>
                      <Col md={1}></Col>
                      <Col md={2}>
                        <Button
                          type="button"
                          onClick={this.props.gotoSelectCandidate}
                          variant="warning"
                          className={classes.nextBtn}
                        >
                          {" "}
                          Previous{" "}
                        </Button>
                      </Col>
                    </Row>
                  </div>
                </>
              )
            ) : (
              <>
                {" "}
                <NoDataErrorScreen msg="Nothing Found" />
                <Row className="justify-content-md-center">
                  <Col md={3}>
                    <Button
                      type="button"
                      variant="warning"
                      className={`${classes.searchButton} ${classes.btnWarning}`}
                      onClick={this.notify}
                    >
                      Notify2 FoxMatrix
                    </Button>
                  </Col>
                </Row>
                <div className={classes.footer}>
                  <Row>
                    <Col md={1}></Col>
                    <Col md={2}>
                      <Button
                        type="button"
                        onClick={this.props.gotoSelectCandidate}
                        variant="warning"
                        className={classes.nextBtn}
                      >
                        {" "}
                        Previous{" "}
                      </Button>
                    </Col>
                  </Row>
                </div>
              </>
            )
          ) : (
            <>
              {" "}
              <ServerErrorScreen />{" "}
              <div className={classes.footer}>
                <Row>
                  <Col md={1}></Col>
                  <Col md={2}>
                    <Button
                      type="button"
                      onClick={this.props.gotoSelectCandidate}
                      variant="warning"
                      className={classes.nextBtn}
                    >
                      {" "}
                      Previous{" "}
                    </Button>
                  </Col>
                </Row>
              </div>
            </>
          )}
          {this.state.show ? (
            <Modal
              email={this.state.email}
              image={this.state.image}
              show={this.state.show}
              id={this.state.id}
              handleClose={this.handleModal}
              totalInterviewTaken={this.state.totalInterviewTaken}
            />
          ) : null}
        </Loader>
        {this.state.availabilityModal ? (
          <Availability
            data={this.props.availability}
            dataId={this.props.id}
            show={this.state.availabilityModal}
            availabilityModalHandler={this.availabilityModalHandler}
            onRadioSelect={this.props.changeText}
            obj={JSON.stringify(this.state.interviwerRadioId)}
            text={this.props.selectedText}
          />
        ) : null}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loader: state.employeeReducer.loader,
    scheduleInterviewInterviewerList:
      state.employeeReducer.scheduleInterviewInterviewerList,
    records: state.employeeReducer.records,
    serverErrorStatus: state.employeeReducer.serverErrorStatus,
    scheduleInterviewInterviewerNodata:
      state.employeeReducer.scheduleInterviewInterviewerNodata,
    sufficientBalance: state.employeeReducer.sufficientBalance,
    remainingBalance: state.employeeReducer.remainingBalance,
    notifyFoxmatrixLoader: state.employeeReducer.notifyFoxmatrixLoader,
    notifyFoxmatrixSuceess: state.employeeReducer.notifyFoxmatrixSuceess,
    notifyFoxmatrixFailMsg: state.employeeReducer.notifyFoxmatrixFailMsg,
    notifyFoxmatrixNetworkError:
      state.employeeReducer.notifyFoxmatrixNetworkError,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getScheduleInterviwerList: (
      page,
      searchFormData,
      jobId,
      selecttypeofInterviewValue,
      cdID
    ) =>
      dispatch(
        actionTypes.getScheduleInterviwerList(
          page,
          searchFormData,
          jobId,
          selecttypeofInterviewValue,
          cdID
        )
      ),
    notifyFoxmatrix: (data) => dispatch(actionTypes.notifyFoxmatrix(data)),
    clearStateNotify: () => dispatch(actionTypes.clearStateNotify()),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(candidateProfile)
);
